// extracted by mini-css-extract-plugin
export var deleteModal = "_ez-0";